module.exports = __webpack_public_path__ + "media/images/icons/Upload-01-766e754ea7672a76e5361724f1873327.svg";